import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-drop-down',
    imports: [FormsModule, ReactiveFormsModule],
    templateUrl: './drop-down.component.html',
    styleUrl: './drop-down.component.scss'
})
export class DropDownComponent {
  @Input() field: any = {};
  @Input() form!: FormGroup;
  get isValid() { return this.form.controls[this.field.name].valid; }
  get isDirty() { return this.form.controls[this.field.name].dirty; }

  constructor() { }

  ngOnInit(): void {

  }
  dropdownevent() {
    console.log(this.form.controls['excutionStatus'], "drop down")
    if (this.form.controls['excutionStatus'] != undefined) {
      if (this.form.value.excutionStatus == 2 || this.form.value.excutionStatus == 3) {
        this.form.controls['feedback'].reset()
        this.form.controls['feedback'].patchValue('-1')
        this.form.controls['feedback'].disable()
      } else {
        this.form.controls['feedback'].enable()
      }
    }
  }
}
